import { render, staticRenderFns } from "./occupatChoice.vue?vue&type=template&id=1d69ac83&scoped=true"
import script from "./occupatChoice.vue?vue&type=script&lang=js"
export * from "./occupatChoice.vue?vue&type=script&lang=js"
import style0 from "./occupatChoice.vue?vue&type=style&index=0&id=1d69ac83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d69ac83",
  null
  
)

export default component.exports